/**
 * Handles the onLoad event for the Google Map.
 * Fits the map bounds to the trail coordinates.
 *
 * @param {google.maps.Map} map - The Google Map instance.
 */
export const mapBounds = trailCoords => {
  const bounds = new window.google.maps.LatLngBounds();
  for (var i = 0; i < trailCoords.length; i++) {
    bounds.extend({
      lat: trailCoords[i].lat,
      lng: trailCoords[i].lng,
    });
  }
  return bounds;
};
